<template>
  <div class="base-input">
    <span>{{ inputValue }}</span>
    <input
      class=""
      placeholder="请输入"
      type="text"
      autofocus
      v-model="inputValue"
      @input="inputChange"
      @focus="handleFocus"
      @blur="handleBlur"
      @keyup.enter="handleSubmit"
    />
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  model: {
    prop: "value",
    event: "input" // 这个event的值'input'对应$emit触发的事件'input'
  },
  props: {
    minWidth: {
      type: String,
      default: "60px"
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  methods: {
    inputChange(e) {
      this.$emit("input", e.target.value);
    },
    handleSubmit(e) {
      e.target.blur();
    },
    handleBlur() {
      this.$emit("onBlur");
    },
    handleFocus() {
      this.$emit("onFocus");
    }
  }
};
</script>

<style lang="less" scoped>
.base-input {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  min-width: 60px;
  border: none;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.6);
  padding: 0 10px;
  font-size: inherit;
  font-weight: inherit;
  span {
    display: inline-block;
    width: 100%;
    height: 100%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    color: transparent;
  }

  input {
    display: inline-block;
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 10px;
    border: none;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.6);
    font-size: inherit;
    font-weight: inherit;
    &::placeholder {
      font-weight: 400;
      color: #92969a;
      font-size: inherit;
    }
  }
}
</style>
